import axios from 'axios'
import Cookies from "js-cookie";
import router from "../router/index"
import loginStore from "../store/modules/login"
import appStore from "../store/modules/app"
// import store from '../store/index';
import store from '../store'
console.log("环境变量", process.env.VUE_APP_DOMAIN);
import {
  Loading,
  Message
} from 'element-ui'
import qs from "qs"

import {
  EditionPayDialog
} from "../dialog"

let loading = null
// create an axios instance
const service = axios.create({
  // baseURL: `https://api.hhmdtech.com`, // url = base url + request url
  // baseURL: `https://api.mdfitnesscao.com`, // url = base url + request url
  baseURL: process.env.VUE_APP_PLATFORM_DOMAIN,
  // baseURL: `http://192.168.31.139:8000`,
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

const domain = {
  "/mcapi": process.env.VUE_APP_DOMAIN,
  "/api": process.env.VUE_APP_PLATFORM_DOMAIN
  // '/test': 'http://192.168.31.139:8000'
};

const sessionKey = "u-merchant-info";
const TokenKey = "authorized-merchant-token";

const getToken = () => {
  // 此处与`TokenKey`相同，此写法解决初始化时`Cookies`中不存在`TokenKey`报错
  return Cookies.get(TokenKey) ?
    JSON.parse(Cookies.get(TokenKey)) :
    sessionStorage.getItem(sessionKey);
}
service.interceptors.request.use(
  config => {
    // let token = "debug"
    loading = Loading.service({
      fullscreen: true,
      text: "拼命加载中",
    });
    config.headers['token'] = getToken() && getToken().token;
    // config.headers['token'] = token;


    const findReplaceDomainKey = Object.keys(domain).find(k =>
      new RegExp(`^${k}`).test(config.url)
    );
    if (findReplaceDomainKey) {
      config.url = config.url.replace(
        new RegExp(`^${findReplaceDomainKey}`),
        domain[findReplaceDomainKey]
      );
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (!response) {
      return Promise.reject(new Error('请求超时'))
    }
    let params = response.config.headers["Content-Type"] && response.config.headers["Content-Type"] != 'multipart/form-data' && response.config.data && JSON.parse(response.config.data);
    // isShowPrompt
    const res = response.data
    if (res.code === 200) {
      console.log(response.config, "哈哈哈")
      loading.close();

      if (!res.data && response.config.url !== '/statisticsService/mechanism/config') {
        EditionPayDialog({
          show: true
        });
        // store.commit('app/SET_TAP_MAP_COUNT', 1)
        return Promise.reject(new Error('暂无数据'))
      }
      return res

    } else {
      console.log(response);
      loading.close();
      if (res.type == 'application/octet-stream') {
        return response
      }
      if (params && params.hiddenPrompt) return Promise.reject(new Error(res.message || 'Error'));
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 3 * 1000
      })
      if ([401, 403].includes(res.code)) {
        console.log("appStore", appStore);
        store.dispatch('app/resetData')
        router.push({
          path: `/login?channel=${store.state.login.channelAccout}`,
          query: {
            redirect: router.currentRoute.path
          }
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    }
    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    loading.close()
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
